import { IProfile } from "./Security";
import { Producer, IFaena } from './Report';

export enum EAccountStatus {
	ACTIVE = 0,
	INACTIVE = 1
}


export interface IAccount {
	username: string;
	password: string;
	name: string;
	idProfile: number;
	profile: IProfile;
	id: number;
	createdAt: Date;
	editedAt?: Date;
	removedAt?: Date;
	version: number;
	quantityBranch: number;
	status: EAccountStatus;
	producers?: Producer[];
	producersList?: IFaena[];
}

export interface IAccountForm {
	id?: number;
	username: string;
	password: string;
	name: string;
	idProfile: number;
	status: EAccountStatus;
	brandsAdd: IBranchAction[];
	brandsDel: IBranchAction[];
}

export interface IBranchAction {
	username: string;
	rutProductor: string;
	sucursal: string;
	permiso: 'S' | 'N';
}
